import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { map } from 'rxjs/operators';
import { getUser } from '@play/state';
import * as i2 from '@ngrx/store';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';

function CaptchaComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "img", 1);
    i0.ɵɵelement(2, "br");
    i0.ɵɵelement(3, "input", 2);
    i0.ɵɵelement(4, "input", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const codeKey_r1 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", "https://play.eslgaming.com" + codeKey_r1.image, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", codeKey_r1.codeKey);
} }
class CaptchaComponent {
    constructor(http, store) {
        this.http = http;
        this.store = store;
    }
    ngOnInit() {
        this.user$ = this.store.select(getUser);
        this.codeKey$ = this.getCaptchaKey().pipe(map(codeKey => codeKey));
        this.isReady$ = this.user$.pipe(map(user => !user.loading && !user.entry));
    }
    getCaptchaKey() {
        return this.http.get("https://play.eslgaming.com/interface/feature/index.php?f=captcha&a=generate");
    }
}
CaptchaComponent.ɵfac = function CaptchaComponent_Factory(t) { return new (t || CaptchaComponent)(i0.ɵɵdirectiveInject(i1.HttpClient), i0.ɵɵdirectiveInject(i2.Store)); };
CaptchaComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CaptchaComponent, selectors: [["play-captcha"]], decls: 3, vars: 5, consts: [[4, "ngIf"], [3, "src"], ["type", "hidden", "name", "code_key", 3, "value"], ["type", "text", "name", "code"]], template: function CaptchaComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CaptchaComponent_ng_container_0_Template, 5, 2, "ng-container", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵpipe(2, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind1(2, 3, ctx.isReady$) && ctx.codeKey$));
    } }, directives: [i3.NgIf], pipes: [i3.AsyncPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CaptchaComponent, [{
        type: Component,
        args: [{
                selector: "play-captcha",
                templateUrl: "./captcha.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: i2.Store }]; }, null); })();

class CaptchaModule {
}
CaptchaModule.ɵfac = function CaptchaModule_Factory(t) { return new (t || CaptchaModule)(); };
CaptchaModule.ɵmod = i0.ɵɵdefineNgModule({ type: CaptchaModule });
CaptchaModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CaptchaModule, { declarations: [CaptchaComponent], imports: [CommonModule], exports: [CaptchaComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CaptchaModule, [{
        type: NgModule,
        args: [{
                declarations: [CaptchaComponent],
                imports: [CommonModule],
                exports: [CaptchaComponent],
            }]
    }], null, null); })();

/*
 * Public API Surface of captcha
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CaptchaComponent, CaptchaModule };
//# sourceMappingURL=play-captcha.js.map
